import { NavLink as NavLinkRouter, type NavLinkProps } from 'react-router-dom'
import { type FC, type RefAttributes, type MouseEventHandler } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { getAriaLabel } from 'shared/lib'

export const NavLink: FC<
  NavLinkProps & RefAttributes<HTMLAnchorElement> & { disabledVueRouting?: boolean }
> = ({ disabledVueRouting, 'aria-label': ariaLabelFromProps, ...props }) => {
  const onClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (props.onClick) {
      props.onClick(e)
    }

    if (!disabledVueRouting) {
      setTimeout(() => {
        if (uiStore.routeBlocker?.state !== 'blocked') {
          uiStore.changeRoute({
            method: 'replace',
            path: window.location.pathname,
            type: 'vue',
          })
        }
      })
    }
  }

  return (
    <NavLinkRouter
      {...props}
      onClick={onClick}
      aria-label={ariaLabelFromProps ?? getAriaLabel('NavLink', `${props.to}`)}
    />
  )
}
